<template>
  <b-container>
    <b-row>
      <b-col
        cols="12"
        sm="12"
        md="12"
        lg="6"
        class="padding-ten-tb float-left padding-left-none"
      >
        <h5 class="title__name">Creación OS</h5>
      </b-col>
    </b-row>
    <b-row>
      <b-col
        xs="12"
        sm="12"
        md="12"
        lg="6"
        class="float-left padding-left-none"
      >
        <h5 class="main__section_title_color text-large">Consulta</h5>
      </b-col>
      <b-col xs="12" sm="12" md="12" lg="6" class="float-right">
        <p class="text-medium color-gray">F. Registro {{ date }}</p>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import moment from "moment";
export default {
  name: "HeaderGeneric",
  data() {
    return {
      date: moment().format("DD-MM-YYYY"),
    };
  },

  methods: {},
};
</script>
<style scoped>
</style>